import { useEffect } from "react";
import { ScaleLoader } from "react-spinners";


function App() {

  useEffect(() => {
    const baseDomain = 'https://www.habibullahftl.com'
    const pathName = window.location.pathname;
    const searchQuery = window.location.search || "";
    const redirectURL = `${baseDomain}${pathName}${searchQuery}`;

    const currentURL = window.location.href;

    if (currentURL !== redirectURL) {
      window.location.replace(redirectURL);
    }
  }, []);

  return (
    <div style={{
      height: '100vh',
      width: '100wh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <ScaleLoader
        color="#2891E7"
        height="80px"
        width="10px"
        margin="5px"
        radius="5px"
      />

    </div>
  );
}

export default App;
